import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatMoney, formatMoneyShorten, remove255 } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { FaRegCommentDots } from "react-icons/fa6";
import { STR_CLICK_TO_VIEW_COMMENTS, STR_COULD_NOT_FETCH_DATA, STR_ENTER_PAYPHONE, STR_ENTER_PHONE_NUMBER_FOR_PAYMENT, STR_GO_BACK, STR_ORDER_NOTES, STR_ORDER_NOTES_HELP_TEXT, STR_OVERALL_COST, STR_PAY_TO_PLACE_ORDER, STR_PAY_WITH_CARD, STR_PAY_WITH_MOBILE, STR_PHARMACY_ORDER_FINAL_TEXT_CARD, STR_PHARMACY_ORDER_FINAL_TEXT_PHONE, STR_PLEASE_SELECT_ITEMS_TO_BUY, STR_PROVIDE_YOUR_ADDRESS, STR_SELECT_PAYMENT_METHOD, STR_SHIPPING_COST, STR_TOTAL_ORDER_PRICE, STR_TRANSACTION_FEES, STR_WRITE_YOUR_COMMENT } from "../Strings";
import LoginView from '../views/LoginView';
import NapaAddressPicker from "../ones/NapaAddressPicker";
import OnePharmacyItemSimple from "../ones/OnePharmacyItemSimple";
import { MdCheckCircle } from "react-icons/md";
import MobileInterface from "../MobileInterface";


export default function View({ type = 'item' }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [itemsData, setItemsData] = useState(null);
	const [shippingCostStructure, setShippingCostStructure] = useState(null);
	const [shippingAddress, setShippingAddress] = useState(null);
	const [orderNotes, setOrderNotes] = useState("");
	
	const [totalOrderPrice, setTotalOrderPrice] = useState(0);
	const [shippingCost, setShippingCost] = useState(0);
	const [transactionFees, setTransactionFees] = useState(0);
	const [overallCost, setOverallCost] = useState(0);

	const [opSuccessful, setOpSuccessful] = useState(false);
	const [loading, setLoading] = useState(false);

	const [payWith, setPayWith] = useState('mobile_money');
	const [payPhone, setPayPhone] = useState(remove255(appContext.currentUserData.phone));

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getItemsData(),
			getShippingCostStructure(),
		]);
		setReady(true);
	}

	function getTotalOrderPrice () {
		let _total = 0;
		if(itemsData && itemsData.length > 0) {
			for (const item of itemsData) {
				_total += (Number(item.unitPrice) * Number(item.itemQuantity));

			}
		}

		return _total;
	}

	function getShippingCost() {
		let _total = 0;

		if(shippingAddress && shippingAddress.region) {

			if(shippingAddress.region === 'DAR ES SALAAM') {
				_total = shippingCostStructure.insideDar;
			} else {
				_total = shippingCostStructure.outsideDar;
			}

		} 

		return _total;
	}

	function getTransactionFees(_totalOrderPrice, _shippingCost) {
		let _total = Number(_totalOrderPrice) + Number(_shippingCost);
		let selcomPercent = appContext.systemParams.selcomPercent;

		// Calculate the total amount to charge to cover the fees
		let totalAmount = _total / (1 - (selcomPercent / 100));

		// The fee is the difference between the total amount to charge and the original total
		let _fees = totalAmount - _total;

		return _fees;
	}

	function getOverallCost(_totalOrderPrice, _shippingCost, _transactionFees) {
		let _total = Number(_totalOrderPrice) + Number(_shippingCost) + Number(_transactionFees);

		return _total;
	}

	async function getItemsData() {
		if(type === 'item' && appContext.pharmacyItemForCheckout) {
			await callApi(
				"get-pharmacy-items-data", 
				{ 
					items: JSON.stringify([appContext.pharmacyItemForCheckout])
				}
			).then(response => {
				if (response.status === 1) {
					setItemsData(response.data);
				} else {
					appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
				}
			})
		} else if(type === 'cart' && appContext.cart && appContext.cart.length > 0) {
			await callApi(
				"get-pharmacy-items-data", 
				{ 
					items: JSON.stringify(appContext.cart)
				}
			).then(response => {
				if (response.status === 1) {
					setItemsData(response.data);
				} else {
					appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
				}
			})
		} else {
			appContext.navBack();
			appContext.tellError(STR_PLEASE_SELECT_ITEMS_TO_BUY[appContext.language])
		}
	}

	async function getShippingCostStructure() {
		if(type === 'item' && appContext.pharmacyItemForCheckout) {
			await callApi(
				"get-pharmacy-shipping-cost-structure", 
				{ 
					items: JSON.stringify([appContext.pharmacyItemForCheckout])
				}
			).then(response => {
				if (response.status === 1) {
					setShippingCostStructure(response.data);
				} else {
					appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
				}
			})
		} else if(type === 'cart' && appContext.cart && appContext.cart.length > 0) {
			await callApi(
				"get-pharmacy-shipping-cost-structure", 
				{ 
					items: JSON.stringify(appContext.cart)
				}
			).then(response => {
				if (response.status === 1) {
					setShippingCostStructure(response.data);
				} else {
					appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
				}
			})
		} else {
			appContext.navBack();
			appContext.tellError(STR_PLEASE_SELECT_ITEMS_TO_BUY[appContext.language])
		}
	}

	async function startOrder() {
		if(itemsData && itemsData.length > 0) {
			if(shippingAddress && shippingAddress.region && shippingAddress.district) {
				if(
					(payPhone && payPhone.trim().length === 10 && payWith === 'mobile_money') ||
					payWith === 'credit_card' 
				) {

					let _items = '[]';

					if(type === 'item') {
						_items = JSON.stringify([appContext.pharmacyItemForCheckout]);
					} else if(type === 'cart') {
						_items = JSON.stringify(appContext.cart)
					}

					setLoading(true);
					await callApi(
						'create-pharmacy-order',
						{
							items: _items,
							shippingAddress: JSON.stringify(shippingAddress),
							payPhone,
							payWith,
							orderNotes, 
						}
					).then(response => {
						if(response.status === 1) {
							setOpSuccessful(true);
							if (payWith === 'credit_card') {
								MobileInterface.openLink(response.payment_gateway_url);
							}

						} else {
							appContext.tellError(response.msg);
						}
					})
					setLoading(false);
				} else {
					appContext.tellError(STR_ENTER_PHONE_NUMBER_FOR_PAYMENT[appContext.language]);
				}
			} else {
				appContext.tellError(STR_PROVIDE_YOUR_ADDRESS[appContext.language]);
			}
		} else {
			appContext.tellError(STR_PLEASE_SELECT_ITEMS_TO_BUY[appContext.language]);
		}
	}

	useEffect(() => {
		if(itemsData) {
			
		}
	}, [itemsData])

	useEffect(() => {
		if(shippingCostStructure) {
			
		}
	}, [shippingCostStructure])

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		setTotalOrderPrice(getTotalOrderPrice());
	}, [ itemsData ]);

	useEffect(() => {
		setShippingCost(getShippingCost());
	}, [ shippingCostStructure, shippingAddress ]);

	useEffect(() => {
		setTransactionFees(getTransactionFees(totalOrderPrice, shippingCost));
	}, [ totalOrderPrice, shippingCost ])


	useEffect(() => {
		setOverallCost(getOverallCost(totalOrderPrice, shippingCost, transactionFees));
	}, [ totalOrderPrice, shippingCost, transactionFees ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if(appContext.auth && appContext.currentUserData) {
		if (ready && itemsData && shippingCostStructure) {
			return (
				<div className="container">

					{
						(opSuccessful) ?
						<div className="row">
							<div className="col-md-12 mt-4 mb-4">
								<h6
									style={{
										fontSize:"18px"
									}}
									className="font-semi-bold text-center mt-4 mb-4"
								>
									<MdCheckCircle size={72} className="text-secondary"/>
									<br/>
									{
										(payWith === 'mobile_money') ?
										STR_PHARMACY_ORDER_FINAL_TEXT_PHONE[appContext.language]
										:""
									}

									{
										(payWith === 'credit_card') ?
										STR_PHARMACY_ORDER_FINAL_TEXT_CARD[appContext.language]
										:""
									}
								</h6>

								<div className="text-center">
									<button
										className="btn btn-padded btn-rounded btn-primary"
										onClick={appContext.navBack}
									>
										{STR_GO_BACK[appContext.language]}
									</button>
								</div>
							</div>
						</div>
						:
						<div className="row">
		
							<div className="col-md-12">
								<NapaAddressPicker callback={setShippingAddress}/>
							</div>

							<div className="col-md-12 mt-4 mb-4">
								{
									(itemsData && itemsData.length > 0) ?
									itemsData.map((item, i) => {
										return (
											<OnePharmacyItemSimple key={i} data={item}/>
										)
									})
									:""
								}
							</div>

							<div className="col-md-12">
								<div className="mt-4 mb-4">
									<label className="form-label">{STR_ORDER_NOTES[appContext.language]}</label>
									<textarea
										className="form-control"
										onChange={(e) => setOrderNotes(e.target.value)}
										value={orderNotes}
									/>
									<div className="form-text">{STR_ORDER_NOTES_HELP_TEXT[appContext.language]}</div>
								</div>

								<div
									className=""
									style={{
										paddingTop: "30px",
										paddingBottom: "30px"
									}}
								>
									<table
										className="table table-striped"
										
									>
										<tbody>
											<tr>
												<td className="" style={{ fontSize: "18px" }}>{STR_TOTAL_ORDER_PRICE[appContext.language]}</td>
												<td className="" style={{ fontSize: "18px" }}>{formatMoney(totalOrderPrice)}</td>
											</tr>
											<tr>
												<td className="" style={{ fontSize: "18px" }}>{STR_SHIPPING_COST[appContext.language]}</td>
												<td className="" style={{ fontSize: "18px" }}>{formatMoney(shippingCost)}</td>
											</tr>
											<tr>
												<td className="" style={{ fontSize: "18px" }}>{STR_TRANSACTION_FEES[appContext.language]}</td>
												<td className="" style={{ fontSize: "18px" }}>{formatMoney(transactionFees)}</td>
											</tr>
											<tr>
												<td className="font-bold" style={{ fontSize: "18px" }}>{STR_OVERALL_COST[appContext.language]}</td>
												<td className="font-bold" style={{ fontSize: "18px" }}>{formatMoney(overallCost)}</td>
											</tr>
										</tbody>
									</table>
								</div>


								<div className="mt-4 mb-4">
									<label className="form-label">{STR_SELECT_PAYMENT_METHOD[appContext.language]}</label>
									<select
										className="form-control"
										value={payWith}
										onChange={(e) => setPayWith(e.target.value)}
									>
										<option value="mobile_money">{STR_PAY_WITH_MOBILE[appContext.language]}</option>
										<option value="credit_card">{STR_PAY_WITH_CARD[appContext.language]}</option>
									</select>
								</div>

								<div className="mt-4 mb-4" style={{ display: (payWith === 'mobile_money') ? 'block' : 'none' }}>
									<label className="form-label">{STR_ENTER_PAYPHONE[appContext.language]}</label>
									<input
										className="form-control"
										value={payPhone}
										onChange={(e) => setPayPhone(e.target.value)}
										maxLength={10}
										minLength={10}
									/>
									<div className="form-text">07XXXXXXXX or 06XXXXXXXX</div>
									
								</div>
									
							</div>

							<div className="col-md-12 mb-4 mt-2">
								<button
									className="btn btn-block btn-rounded btn-padded btn-primary mb-4"
									onClick={startOrder}
								>
									{STR_PAY_TO_PLACE_ORDER[appContext.language]}
								</button>
							</div>

						</div>
						
						
					}

				</div>
			)
		} else {
			return (
				<div
					className="mSupportLoading container"
				>
					{getInlineLoader()}
				</div>
			);
		}
	} else {
		return (
			<LoginView/>
		)
	}


}